// stores/leaveProtectionStore.ts
import { defineStore } from 'pinia';

export const useLeaveProtectionStore = defineStore('leaveProtectionStore', {
    state: () => ({
        hasUnsavedChanges: false // 控制是否有未儲存的更改
    }),
    actions: {
        setUnsavedChanges(status: boolean) {
            this.hasUnsavedChanges = status;
        }
    }
});
